import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const categories = ['Evaluación', 'Diagnóstico', 'Seguimiento', 'Informes', 'Obras Sociales', 'Gestión'];
const pills = ['Excel', 'Google Sheets', 'Word', 'PDF', 'Editables', 'Imprimibles', 'Goniometría', 'Escalas'];
export function BrandBlock() {
  return <section className="py-12 md:py-20 bg-slate-50" data-id="element-55">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-brand-accent rounded-3xl p-6 md:p-10 text-white shadow-xl relative overflow-hidden" data-id="element-57">
          {/* Decorative blobs */}
          <div className="absolute -top-16 -right-16 w-48 h-48 bg-white/10 rounded-full pointer-events-none" data-id="element-58"></div>
          <div className="absolute -bottom-20 -left-20 w-56 h-56 bg-white/5 rounded-full pointer-events-none" data-id="element-59"></div>

          <div className="relative z-10 text-center" data-id="element-60">
            {/* Top badge */}
            <div className="inline-flex items-center gap-2 bg-white/15 backdrop-blur-sm rounded-full px-3 py-1.5 mb-6 border border-white/20" data-id="element-61">
              <CheckIcon className="w-3.5 h-3.5" strokeWidth={3} data-id="element-62" />
              <span className="text-[11px] md:text-xs font-bold uppercase tracking-wider" data-id="element-63">
                Sistema N°1 en Argentina
              </span>
            </div>

            {/* Stats row */}
            <div className="grid grid-cols-2 gap-4 mb-8 max-w-md mx-auto" data-id="element-64">
              <div data-id="element-65">
                <div className="text-3xl md:text-5xl font-black leading-none" data-id="element-66">
                  +100
                </div>
                <div className="text-[11px] md:text-sm text-white/80 mt-1 uppercase tracking-wider" data-id="element-67">
                  planillas
                </div>
              </div>
              <div className="border-l border-white/25 pl-4" data-id="element-68">
                <div className="text-3xl md:text-5xl font-black leading-none" data-id="element-69">
                  4
                </div>
                <div className="text-[11px] md:text-sm text-white/80 mt-1 uppercase tracking-wider" data-id="element-70">
                  formatos
                </div>
              </div>
            </div>

            {/* Categories line */}
            <p className="text-xs md:text-base font-bold mb-6 leading-relaxed" data-id="element-71">
              {categories.map((cat, i) => <span key={cat} data-id="element-72">
                  {cat}
                  {i < categories.length - 1 && <span className="mx-1.5 opacity-50" data-id="element-73">·</span>}
                </span>)}
            </p>

            {/* Pills */}
            <div className="flex flex-wrap justify-center gap-2" data-id="element-74">
              {pills.map(pill => <span key={pill} className="bg-white/15 backdrop-blur-sm border border-white/20 text-white text-[10px] md:text-xs font-semibold px-3 py-1.5 rounded-full" data-id="element-75">
                  {pill}
                </span>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}